module.exports = __webpack_public_path__ + "img/icon-counter-view.28b6033e.svg";